import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NavService } from '../_services/_nav.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AutenticacionService } from '../_services/autenticacion.service';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { RespuestaAutenticacion } from '../_models/respuesta-autenticacion';
import { AppSettings } from '../../proyect.conf';

@Injectable()
export class RequestsInterceptor implements HttpInterceptor {

  private refrescandoToken = false;
  private refrescandoTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  contador401 = 0;

  constructor(private autServicio: AutenticacionService, private injector: Injector) {}

  /* MA4453: el backend bloquea con 409 el cambio de estado cuando la solicitud jurídica no tiene
     representante legal principal.*/
  private mostrarBloqueoCambioEstado(req: HttpRequest<any>, error: HttpErrorResponse) {
    if (error.status !== 409 || !req.url.includes('solicitudes/cambioEstado') || typeof error.error !== 'string') {
      return;
    }
    try {
      const navServicio = this.injector.get(NavService);
      /* se usa el toast para mostrar mensaje */
      navServicio.setMesageToast({
        key: 'toastMessage',
        life: 15000,
        severity: 'warn',
        summary: navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: error.error
      });
    } catch (e) {
      console.error('No fue posible mostrar el mensaje de cambio de estado', e);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Obtener token antes de enviar la solicitud
    let token = this.autServicio.obtenerToken();

    if (token) {
      req = this.agregarToken(req, token);
    }

    if (!req.headers.has('Content-Type') && !req.headers.has('Hidden-Content') &&
      ((req.url !== (AppSettings.rutServiciosADJ + '/api/adjuntos') &&
        req.url !== (AppSettings.rutServiciosTER + '/api/adjuntosTerceros') &&
        !req.url.includes(AppSettings.rutServicios + '/api/upload') &&
        !req.url.includes(AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesAdjuntosCargue/validarRegistrosAdjunto/riesgoSarlaftVariable')) ||
        req.method !== 'POST')) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    }

    if (!req.url.includes('auth/login') && !req.url.includes('/api/session/') && req.body &&
      (req.method === 'PUT' || req.method === 'POST') && localStorage.getItem('ipClient')) {
      req = req.clone({ headers: req.headers.set('REMOTE-CLIENT', localStorage.getItem('ipClient')!) });
    }

    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.contador401 = this.contador401 + 1;
          if (this.contador401 === 4)
          {
            this.cerrarSesion()
          } else
          {
            return this.refrescarToken(req, next);
          }
        } else {
          if (error instanceof HttpErrorResponse) {
            this.mostrarBloqueoCambioEstado(req, error);
          }
          return throwError(error);
        }
      })
    );
  }

  cerrarSesion() {
    this.autServicio.cerrarSesion();
    window.location.href = '/';
  }

  private agregarToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `${token}`
      }
    });
  }

  private refrescarToken(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.refrescandoToken) {
      this.refrescandoToken = true;
      this.refrescandoTokenSubject.next(null);

      return this.autServicio.refrescarToken().pipe(
        switchMap((rta: RespuestaAutenticacion) => {
          if (rta && rta.estado) {
            this.autServicio.actualizarToken(rta.respuesta);
            this.refrescandoToken = false;
            this.refrescandoTokenSubject.next(rta.respuesta);
            return next.handle(this.agregarToken(request, rta.respuesta));
          } else {
            this.cerrarSesion();
            return throwError('Error al refrescar el token');
          }
        }),
        catchError((error) => {
          this.refrescandoToken = false;
          this.cerrarSesion();
          return throwError(error);
        })
      );
    } else {
      return this.refrescandoTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.agregarToken(request, token));
        })
      );
    }
  }
}
